import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import FieldSelect from '../../../components/general/fields/fieldSelect';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { useTenderFilters } from './hook';
import { TenderProps } from './props';
import dayjs from 'dayjs';
import DatePickerField from '../../../components/general/fields/datePickerField';
import { ISelect } from '../../../../shared/types/shared';

export const TenderFilters = ({ onFilter, loading }: TenderProps) => {
    const { formik, statusProcessOptions } = useTenderFilters(onFilter);

    return (
        <Grid container spacing={{ xs: 1.5, md: 1.5 }}>
            <Grid item xs={12} sm={6} md={3}>
                <FieldText
                    label="Nombre proponente"
                    name="bidder"
                    value={formik.values.bidder}
                    onChange={formik.handleChange}
                    touched={formik.touched.bidder}
                    errors={formik.errors.bidder}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('startCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    minDate={dayjs(formik.values.startCreatedAt)}
                    maxDate={dayjs().endOf('day')}
                    disabled={!formik.values.startCreatedAt}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('endCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <FieldText
                    label="Búsqueda por palabra clave"
                    name="keyword"
                    value={formik.values.keyword}
                    onChange={formik.handleChange}
                    touched={formik.touched.keyword}
                    errors={formik.errors.keyword}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <FieldSelect
                    data={statusProcessOptions}
                    label="Etapa de proceso"
                    name="statusProcess"
                    value={
                        typeof formik.values.statusProcess === 'string'
                            ? formik.values.statusProcess
                            : (
                                  formik.values.statusProcess as ISelect
                            )?.id?.toString() ?? ''
                    }
                    onChange={formik.handleChange}
                    touched={formik.touched.statusProcess}
                    errors={formik.errors.statusProcess}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
